var React = require('react');

function ChoiceCardArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"choice-card-arrow","data-name":"choice-card-arrow","d":"M13,0V13H0","transform":"translate(0 9.899) rotate(-45)","fill":"none","strokeWidth":"2"}));
}

ChoiceCardArrowInline.defaultProps = {"width":"19.799","height":"19.799","viewBox":"0 0 19.799 19.799"};

module.exports = ChoiceCardArrowInline;

ChoiceCardArrowInline.default = ChoiceCardArrowInline;
